<template>
  <div class="flex mx--2">
    <div class="px-2px" :class="`w-${labelWidth}`">
      <div class="h-10 text-gray-500 bg-gray-100 px-2">
        <div class="flex items-center h-full">
          <span class="mr-2">{{ label }}</span>
        </div>
      </div>
    </div>
    <div :class="`w-full--${labelWidth} px-2px`">
      <div :class="`flex h-10 bg-white text-black items-center px-2 truncate leading-normal pr-8`">
        <div>{{ adjustment }}</div>
        <div>
          <i class="el-icon-right"></i>
        </div>
        <div>{{ currentValue }}</div>
        <div class="pl-4 hover:text-red-500" @click="onShowAdjustment()">
          <i class="el-icon-info"></i>
        </div>
      </div>
    </div>
  </div>
  <AdjustmentDataDialog
    v-if="isShowModal"
    v-model:isShow="isShowModal"
    :customFieldKey="customFieldKey"
    :label="label"
  />
</template>

<script lang="ts">
import AdjustmentDataDialog from '@/components/barcode/AdjustmentDataDialog.vue'
import BarcodeRowMixin from '@/components/mixins/BarcodeRowMixin.vue'
import IconAddressLocation from '@/components/svg/IconAddressLocation.vue'
import IconCopy from '@/components/svg/IconCopy.vue'
import { Options } from 'vue-class-component'
import { Mixins, Prop } from 'vue-property-decorator'

@Options({
  components: {
    IconCopy,
    IconAddressLocation,
    AdjustmentDataDialog,
  },
  name: 'BarcodeRow',
})
export default class BarcodeRow extends Mixins(BarcodeRowMixin) {
  @Prop({ type: String }) readonly label?: string
  @Prop({ type: String }) readonly customFieldKey?: string
  @Prop({ type: String }) readonly adjustment?: string
  @Prop({ type: String }) readonly currentValue?: string

  isShowModal = false

  onShowAdjustment() {
    this.isShowModal = true
  }
}
</script>
